var _this = this;

import api from "../../api/api.js";
var permissions = {
  taskManage: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  },
  deviceManage: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  },
  groupManage: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  },
  fileMenu: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  },
  userManage: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  },
  noticeManage: {
    all: false,
    add: false,
    edit: false,
    delete: false,
    move: false,
    export: false,
    import: false
  }
};
api.getPermission({
  usersssid: localStorage.getItem('sssid')
}).then(function (res) {
  if (res.state) {
    permissions.taskManage = res.value.TaskPermission;
    permissions.deviceManage = res.value.TrackerPermission;
    permissions.groupManage = res.value.TrackerGroupPermission;
    permissions.fileMenu = res.value.FilePermission;
    permissions.userManage = res.value.UserPermission;
    permissions.noticeManage = res.value.MessagePermission;
  } else {
    _this.$message.error(res.value.text);
  }
});
var imei = "";
export default {
  permissions: permissions,
  imei: imei
};